import './error';
import './sticky';
import './form';
import './applicant/signup';
import './applicant/signup_activate';
import './applicant/password';
import './applicant/password_reset';
import './applicant/page/upload_request';
import './applicant/session_timeout';
import './applicant/reply';

import './script';
import './applicant/wizard';

window.addEventListener('load', async () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateTitle();
    });
  });

  const sticky = document.querySelector('.h1-container') as HTMLElement;
  if (sticky) {
    const update = () => {
      const header = document.querySelector('.header')!.getBoundingClientRect();
      sticky.style.top = `${header.height}px`;
    };
    update();
    window.addEventListener('resize', update);
  }

  const select = document.querySelector('#language') as HTMLSelectElement;
  if (!select)
    return;
  select.addEventListener('change', () => {
    Array.from(select.options).forEach(option => {
      document.documentElement.classList.remove(option.value);
    });
    const language = select.options[select.selectedIndex]!.value;
    document.documentElement.classList.add(language);
    const expires = new Date;
    expires.setFullYear(expires.getFullYear() + 1);
    const cookie = [
      `language=${language}`,
      `path=/${location.pathname.split('/')[1]}`,
      'samesite=lax',
      `expires=${expires.toUTCString()}`,
    ];
    document.cookie = cookie.join('; ');
    updateTitle();
  });
});

function updateTitle() {
  const h1 = document.querySelector('h1');
  if (h1)
    document.title = h1.innerText;
}
